let resources = []

// UNITS //
import {units} from "@frog/source/data/units.js"
Object.values(units).forEach((unit) => {
    if(unit.images != undefined) {
        // if(unit.images.portrait != undefined) {
        //     resources.push(unit.images.portrait)
        // }
        if(unit.images.sprites != undefined) {
            Object.values(unit.images.sprites).forEach((sprite) => {
                if(sprite.frames != undefined) {
                    resources = resources.concat(sprite.frames.map((frame) => frame.image))
                } else if(sprite instanceof Array) {
                    resources = resources.concat(sprite.map((frame) => frame.image))
                } else {
                    resources.push(sprite)
                }
            })
        }
    }
})

// ENCOUNTERS //
import chapters from "@frog/source/data/encounters/chapters.js"
Object.values(chapters).forEach((encounter) => {
    if(encounter.background) resources.push(encounter.background)
    if(encounter.foreground) resources.push(encounter.foreground)
})

// ANIMATIONS //
// import {TILE_ANIMATIONS} from "@frog/source/data/tiles.js"
const animations = [
    // require("@frog/source/assets/images/hero-tactics/ui/fe-cursor/standard/animation.js"),
    // require("@frog/source/assets/images/hero-tactics/ui/fe-range/blue/animation.js"),
    // require("@frog/source/assets/images/hero-tactics/ui/fe-range/red/animation.js"),
    // require("@frog/source/assets/images/hero-tactics/ui/fe-range/green/animation.js"),
    require("@frog/source/assets/images/hero-tactics/ui/fe-end-turn-fade/animation.js"),
]
animations.forEach((animation) => {
    resources = resources.concat(Object.values(animation.frames).map((frame) => frame.image))
})

// TILESETS //
import Tiled from "@frog/source/utility/Tiled.js"
const tileset = Tiled.parseTileset(require("@frog/source/assets/images/apocalypse-tactics/environment/tiles/tileset.json"))
resources = resources.concat(Object.values(tileset.tiles).map((tile) => tile.imageSource))


// INDIVIDUAL IMAGES //
resources = resources.concat([
    require("@frog/source/assets/images/apocalypse-tactics/ui/cursor.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/range/blue-range.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/range/green-range.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/range/red-range.png").default,

    require("@frog/source/assets/images/apocalypse-tactics/ui/banners/your-turn.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/banners/enemy-turn.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/banners/lets-go.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/banners/lose.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/banners/win.png").default,

    require("@frog/source/assets/images/apocalypse-tactics/ui/buttons/undo.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/buttons/end.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/buttons/start.png").default,

    require("@frog/source/assets/images/apocalypse-tactics/ui/arrow/south-start.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/arrow/east-start.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/arrow/west-start.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/arrow/north-start.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/arrow/south-end.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/arrow/east-end.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/arrow/west-end.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/arrow/north-end.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/arrow/north-south.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/arrow/south-west.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/arrow/south-east.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/arrow/east-west.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/arrow/north-east.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/arrow/south-east.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/arrow/east-west.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/arrow/north-west.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/arrow/south-west.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/arrow/north-south.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/arrow/north-west.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/arrow/north-east.png").default,

    require("@frog/source/assets/images/apocalypse-tactics/environment/backgrounds/background-0-full.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/environment/backgrounds/background-1-full.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/environment/backgrounds/background-2-full.png").default,

    require("@frog/source/assets/images/apocalypse-tactics/ui/box/dialogue1.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/box/dialogue2.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/box/dialogue3.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/box/dialogue4.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/box/dialogue5.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/box/dialogue6.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/box/dialogue7.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/box/dialogue8.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/box/dialogue9.png").default,

    require("@frog/source/assets/images/apocalypse-tactics/units/shadow.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/units/shadow_lg.png").default,

    require("@frog/source/assets/images/apocalypse-tactics/ui/title.png").default,

    require("@frog/source/assets/images/apocalypse-tactics/shadow-320-to-384.png").default,

    // require("@frog/source/assets/images/pirate-tactics/units/palette-red.png").default,
    // require("@frog/source/assets/images/pirate-tactics/units/palette-green.png").default,
    // require("@frog/source/assets/images/pirate-tactics/units/palette-blue.png").default,
    // require("@frog/source/assets/images/pirate-tactics/units/palette-purple.png").default,
    // require("@frog/source/assets/images/pirate-tactics/units/palette-gray.png").default,
])

// FONTS //
const fonts = [
    require("@frog/source/assets/images/apocalypse-tactics/ui/fonts/labels/index.js").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/fonts/dialogue/index.js").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/fonts/numbers/index.js").default,
].forEach((font) => {
    resources = resources.concat(Object.values(font.characters))
})

export default resources
